import { styled } from "styled-components";

export const Text = styled.div`
  padding: 4px 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textFade};
`;
